export const Timeframe = {
  PeakAM: 'peak_am',
  PeakPM: 'peak_pm',
  OffPeak: 'offpeak',
  Weekends: 'weekend',
  All: 'all',
};

export const Direction = {
  Inbound: 'inbound',
  Outbound: 'outbound',
  All: 'all',
};

export const Period = {
  Day: 'day',
  Week: 'week',
  Month: 'month',
  Year: 'year',
};

export const Compare = {
  Previous: 'previous',
};

export const SortBy = {
  MostRecent: 'most-recent',
  Earliest: 'earliest',
};

export const PEAKS_DEFIINITION = [
  {
    end_time: '09:00:00',
    label: 'peak_am',
    start_time: '06:00:00',
  },
  {
    end_time: '19:00:00',
    label: 'peak_pm',
    start_time: '16:00:00',
  },
];

export const ON_TIME_RANGE = [-5, 2];

export const CONDITIONAL_PRIORITY_DEFAULTS = {
  lateness: 2,
  schedule_adherence: false,
  occupancy: 'STANDING_ROOM_ONLY',
  occupancy_threshold: false,
  requires: 'ALL',
};

export const OFF_TRIP_MODE_DEFAULTS = {
  mode: 'DISABLED',
};

export const TimeZone = {
  Central: 'Central',
  Mountain: 'Mountain',
  Eastern: 'Eastern',
  Pacific: 'Pacific',
  Arizona: 'Arizona',
  Newfoundland: 'Newfoundland',
  Atlantic: 'Atlantic',
  Saskatchewan: 'Saskatchewan',
};

export const Metric = {
  ScheduleDeviation: 'scheduleDeviation',
  OnTimePercentage: 'onTimePercentage',
  SignalDelay: 'signaldelay',
  TravelTime: 'traveltime',
  DwellTime: 'dwelltime',
  DriveTime: 'drivetime',
};

export const Make = {
  GTT: 'GTT',
  SierraWireless: 'Sierra Wireless',
  Cradlepoint: 'Cradlepoint',
  Whelen: 'Whelen',
  Teletrac: 'Teletrac',
};

export const Model = {
  GTT2100: '2100',
  GTT2101: '2101',
  GTT2150: '2150',
  GTT2151: '2151',
  MP70: 'MP-70',
  VSG: 'VSG',
  IBR900: 'IBR900',
  IBR1700: 'IBR1700',
  R1900: 'R1900',
  Integration: 'Integration',
  MG90: 'MG-90',
};

export const SourceDevice = {
  'CRADLEPOINT-TSP': 'Cradlepoint',
  'CRADLEPOINT-EVP': 'Cradlepoint',
  '2101-TSP': '2101',
  '2100-EVP': '2100',
  'MP70-TSP': 'MP70',
  'MP70-EVP': 'MP70',
  CVP: 'CVP',
  'RT_GTFS-INTERPOLATED': 'RT GTFS',
  'MG90-TSP': 'MG90',
};

export const MakeModels = {
  [Make.GTT]: [
    Model.GTT2100,
    Model.GTT2101,
    Model.GTT2150,
    Model.GTT2151,
    Model.Integration,
  ],
  [Make.SierraWireless]: [Model.MP70, Model.MG90],
  [Make.Cradlepoint]: [Model.IBR1700, Model.R1900, Model.IBR900],
  [Make.Whelen]: [Model.Integration],
  [Make.Teletrac]: [Model.Integration],
};

/**
 * @readonly
 * @enum {string}
 */
export const UserType = {
  Customer: 'Customer',
  MioAdmin: 'MioAdmin',
  MioViewer: 'MioViewer',
};

/**
 * @readonly
 * @enum {string}
 */
export const UserRole = {
  ORG_ADMIN: 'ORG_ADMIN',
  READ_WRITE: 'READ_WRITE',
  VIEW_ONLY: 'VIEW_ONLY',
};

export const Integration = {
  Whelen: 'Whelen',
};
